import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel, SORT_ORDER } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { bulkDownloadETS, fetchETS, fetchEtsPageForDownload, resetETS } from 'actions/ets';
import { displayFilters } from 'actions/filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { IEquipments } from 'reducers/equipments/models';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { ETSCols } from './models';
import { UploadSection } from 'modules/bulk-upload/upload-section';
import { BulkDownload } from 'modules/bulk-download/bulk-download';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { searchFCRStatuses, searchProductTypes, searchCBLStatuses } from 'constants/statuses';
import { Search } from '../Search';
import { originDestDropdown, messageDropdown, uamType, pricingSourceOptions } from '../../../../constants/customs';
import { setFilter } from 'actions/filters';
import { formatValueIfNullOrUndefined, getAgingBucket, lastThreeMonthsFilters } from 'utilities/util';
import { ModalMain } from 'damco-components';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import CustomTable from 'components/custom-table';

interface IMapDispatchToProps {
    fetchETS: (pageNumber: number, pageSize: number) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    resetETS: () => void;
    bulkDownloadETS: (exportJobIds: any) => Promise<void>;
    fetchEtsPageForDownload: (pageNumber: number, pageSize: number) => Promise<any[]>;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    ets: IEquipments | any;
    currentFilters: any,
    filters: any;
    featureToggles: IFeatureToggleModel[];
    userPermissions: any;
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    genericFilter: string;
    withoutFilters: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    filtersApplied: boolean,
    clearFilters: boolean,
    isFetchinProgress: boolean;
    pendingError: string | string[];
    etaFrom: boolean,
    etdFrom: boolean,
    jobCreationDateFrom: boolean,
    typeOfSearch: string,
    ets: any[],
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null;
    showUploadModal: boolean;
    showDownloadModal: boolean;
    isPaginationClicked: boolean;
    bulkUploadTitle: string;
}
export class _SearchEts extends Component<IProps, IState> {
    public tableRef: any = React.createRef();

    public state = {
        sorted: [],
        genericFilter: '',
        withoutFilters: false,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        etaFrom: false,
        etdFrom: false,
        jobCreationDateFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.EQUIPMENT,
        ets: [],
        filtersApplied: false,
        clearFilters: false,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: '',
        showUploadModal: false,
        showDownloadModal: false,
        bulkUploadTitle: '',
        isPaginationClicked: false
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        let filters = this.props.location.search.includes('targetQuery=jobCostingFiltersETS') ? true : false;
        if (!filters && this.props.filters && this.props.filters.hasOwnProperty('jobCostingFiltersETS') && this.props.filters.jobCostingFiltersETS) {
            filters = true;
        }
        this.props.displayFilters(filters, 'jobCostingFiltersETS');
        this.setState({
            isFetchinProgress: false,
            withoutFilters: filters
        });
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            });
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.currentFilters.originDestination !== props.currentFilters.originDestination) {
            const selectedOrigin = this.props.currentFilters.originDestination.split('/')[0];
            const selectedDestination = this.props.currentFilters.originDestination.split('/')[1] === '-' ? '-' : this.props.currentFilters.originDestination.split('/')[1];
            this.props.setFilter('OriginService', selectedOrigin);
            this.props.setFilter('destinationService', selectedDestination);
        }
        if (this.props.ets !== props.ets) {
            this.setData(this.props.ets.result, this.props.ets.page, this.props.ets.pageSize, this.props.ets.totalCount);
            this.setState({
                totalCount: this.props.ets.totalCount
            });
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            });
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
    }

    public componentWillUnmount() {
        this.props.resetSort();
    }

    public onClickBulkUpload = () => {
        this.setState({
            showUploadModal: true,
            bulkUploadTitle: 'Upload charges from file'
        });
    };

    public clickEventHandler = () => {
        this.setState({
            isPaginationClicked: true
        });
    };

    public handlePageSizeChange = (pageSize: number) => {
        localStorage.setItem('pageSize-ListTable jobCosting-search-ets', pageSize.toString());
        this.setState({
            page: 1,
            pageSize,
        });
        this.targetFetch(1, pageSize);
    };

    public handleNextPage = () => {
        if (this.state.totalCount && this.state.pageSize) {
            const pages = Math.ceil(this.state.totalCount / this.state.pageSize);
            if (this.state.page && this.state.page === pages) {
                return;
            } else {
                this.setState((prevState) => ({
                    page: prevState.page ? prevState.page + 1 : 2,
                }), () => {
                    this.targetFetch(this.state.page);
                });
            }
        }
    };

    public handlePreviousPage = () => {
        if (this.state.page && this.state.page > 1) {
            this.setState((prevState) => ({
                page: prevState.page && prevState.page - 1,
            }), () => {
                this.targetFetch(this.state.page);
            });
        } else {
            return;
        }
    };

    public handlePageChange = (page: number) => {
        this.setState({
            page,
        }, () => {
            this.targetFetch(page);
        });
    };

    public handleSorting = (data: any) => {
        this.props.setSort({
            column: data.id,
            order: data.desc ? SORT_ORDER.DESCENDING : SORT_ORDER.ASCENDING,
            desc: data.desc
        });
        this.targetFetch(this.state.page, this.state.pageSize);
    };

    public render() {
        const isBulkFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_IMPORT, this.props.featureToggles);
        const isBulkFeatureDownloadEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES, this.props.featureToggles);
        const isBulkSelectForDownloadEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_SELECT_FOR_DOWNLOAD, this.props.featureToggles);
        const permissions = this.props.userPermissions?.permissions?.find((permission: any) => permission?.businessCapabilityName === uamType.JOBCOSTING || permission?.businessCapabilityName === uamType.ADMIN);
        const isBKSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BKS_EXTRA_DOC, this.props.featureToggles);
        const isDCSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_DCS_EXTRA_DOC, this.props.featureToggles);
        const isMciChargeEnabled = isFeatureEnabled(FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED, this.props.featureToggles);
        const productTypes = [...searchProductTypes];
        if (isDCSFeatureEnabled) {
            productTypes.push({ optionText: 'DCS', value: 'DCS' });
        }
        const filtersToAdd = [
            <FiltersInput
                key="ReferenceNumbers"
                name="ReferenceNumbers"
                label="ETS Number"
                id={'ReferenceNumbers'}
            />,
            <FiltersInput
                key="EquipmentNumber"
                name="EquipmentNumber"
                label="Equipment Number"
                id={'equipmentNumber'}
            />,
            <FiltersInput
                key="CBLNumber"
                name="CBLNumber"
                label="CBL Number"
                id={'cblNumber'}
            />,
            
            <FiltersSelect
                key="cblStatus"
                name="cblStatus"
                id="cblStatus"
                label="CBL Status"
                options={[
                    ...searchCBLStatuses
                ]}
            />,
            <FiltersSelect
                key="FinopsStatus"
                name="FinopsStatus"
                id="status"
                label="FinOps Status"
                options={[
                    ...searchFCRStatuses
                ]}
            />,
            <FiltersInput
                key="SAPSONumber"
                name="SAPSONumber"
                label="SAP SO. Number"
                id={'soNumber'}
            />,
            <FiltersInput
                key="consigneeBECode"
                name="consigneeBECode"
                id="consigneeBECode"
                label="Consignee (BE Code)"
            />,
            <FiltersInput
                key="shipperBECode"
                name="shipperBECode"
                id="shipperBECode"
                label="Shipper (BE Code)"
            />,
            <FiltersInput
                key="contractualPartyBusinessEntityCode"
                name="contractualPartyBusinessEntityCode"
                id="contractualPartyBusinessEntityCode"
                label="Contractual Party (BE Code)"
            />,
            <FiltersInput
                key="salesOrg"
                name="salesOrg"
                id="salesOrg"
                label="Sales Organization"
            />,
            <FiltersSelect
                key="source"
                name="source"
                id="source"
                label="Pricing Source"
                isRequired={false}
                options={pricingSourceOptions}
            />,
            <FiltersInput
                key="CarrierCode"
                name="CarrierCode"
                id="carrier"
                label="Carrier Code"
            />,
            <FiltersSelect
                key="originDestination"
                name="originDestination"
                id="originDestination"
                label="Origin / Destination Service"
                isRequired={false}
                options={originDestDropdown}
            />,
            <FiltersSelect
                key="errorMessage"
                name="errorMessage"
                id="errorMessage"
                label="Error Message"
                isRequired={false}
                options={messageDropdown}
            />,
            <FiltersDateInput
                key="jobCreationDateFrom"
                name="jobCreationDateFrom"
                id="jobCreationDateFrom"
                label="Job Creation Date (From)"
                relatedField="jobCreationDateTo"
                type="dateFromTo"
                setValidity={(val: any) => this.setState({ jobCreationDateFrom: val })}
                isInvalid={this.state.jobCreationDateFrom}
                value=""
                withTime={false}
            />,
            <FiltersDateInput
                key="jobCreationDateTo"
                name="jobCreationDateTo"
                id="jobCreationDateTo"
                label="Job Creation Date (To)"
                minValue="jobCreationDateFrom"
                setValidity={(val: any) => this.setState({ jobCreationDateFrom: val })}
                isInvalid={this.state.jobCreationDateFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="etaFrom"
                name="etaFrom"
                id="etaFrom"
                label="ETA (From)"
                relatedField="etaTo"
                setValidity={(val: any) => this.setState({ etaFrom: val })}
                isInvalid={this.state.etaFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="etaTo"
                name="etaTo"
                id="etaTo"
                label="ETA (To)"
                minValue="etaFrom"
                setValidity={(val: any) => this.setState({ etaFrom: val })}
                isInvalid={this.state.etaFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="etdFrom"
                name="etdFrom"
                id="etdFrom"
                label="ETD (From)"
                relatedField="etdTo"
                setValidity={(val: any) => this.setState({ etdFrom: val })}
                isInvalid={this.state.etdFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="etdTo"
                name="etdTo"
                id="etdTo"
                label="ETD (To)"
                minValue="etdFrom"
                setValidity={(val: any) => this.setState({ etdFrom: val })}
                isInvalid={this.state.etdFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersInput
                key="placeOfReceipt"
                name="PlaceofReceipt"
                id="PlaceofReceipt"
                label="Place of Receipt"
            />,
            <FiltersInput
                key="portofLoading"
                name="PortofLoading"
                id="PortofLoading"
                label="Port of Loading"
            />,
            <FiltersInput
                key="portOfDischarge"
                name="PortOfDischarge"
                id="PortOfDischarge"
                label="Port Of Discharge"
            />,
            <FiltersInput
                key="placeOfDelivery"
                name="PlaceOfDelivery"
                id="PlaceofDelivery"
                label="Place of Delivery"
            />
        ];
        if (isMciChargeEnabled) {
            filtersToAdd.splice(3, 0,<FiltersInput
                key="frn"
                name="frn"
                label="FRN"
                id={'frn'}
            />,);
        }
        if (isBKSFeatureEnabled) {
            filtersToAdd.splice(4, 0, <FiltersSelect
                key="productType"
                name="productType"
                id="productType"
                label="Product Type"
                options={[
                    ...productTypes
                ]}
            />);
        }

        return (
            <Search triggerFetch={() => this.targetFetch()} withoutFilters={this.state.withoutFilters}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingFiltersETS"
                    requireFilters={true}
                    defaultFilters={lastThreeMonthsFilters('jobCreationDateFrom', 'jobCreationDateTo')}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    filters={filtersToAdd}
                    withoutFilters={this.state.withoutFilters}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.etaFrom || this.state.etdFrom || this.state.jobCreationDateFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        this.updatePagination(1);
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            ets: [],
                            clearFilters: false,
                            hasData: false
                        });
                    }}
                />
                <TabComponent name="search-results" activeTab={0} navLinks={[{
                    id: 1,
                    title: 'ETS',
                    emptyLabel: ''
                }
                ]} />
                {this.state.showUploadModal &&
                    <div className="uploadModal">
                        <ModalMain height={450}
                            modal={this.state.showUploadModal}
                            title={this.state.bulkUploadTitle}
                            hideMethod={() => this.setState({ showUploadModal: false })}
                            secondaryMethod={() => this.setState({ showUploadModal: false })}
                            primaryMethod={() => this.setState({ showUploadModal: false })} btnTitle1={'OK'} btnTitle2={'Close'}>
                            <UploadSection
                                name={'upload-control'}
                                refreshName={'upload-control-refresh'}
                                fileFormats={'.xlsx'}
                                restrictionText={'Optional upload text'}
                                entityType={'FinOpsImport'}
                                catagory={'import'}
                            />
                        </ModalMain></div>}

                {this.state.showDownloadModal &&
                    <div className="uploadModal">
                        <ModalMain height={330}
                            modal={this.state.showDownloadModal}
                            title={'Download charges to file'}
                            hideMethod={() => this.setState({ showDownloadModal: false })}
                            secondaryMethod={() => this.setState({ showDownloadModal: false })}
                            primaryMethod={() => this.setState({ showDownloadModal: false })} btnTitle1={'OK'} btnTitle2={'Close'}>
                            <div>
                                <BulkDownload catagory={'import'} />
                            </div>
                        </ModalMain></div>}
                <CustomTable
                    tableId="jobCosting-search-ets"
                    isBulkFeatureEnabled={isBulkFeatureEnabled}
                    isFeatureEnabled={isBulkFeatureDownloadEnabled}
                    hasUAMPermission={permissions?.permission !== '' ? true : false}
                    columns={ETSCols(isBKSFeatureEnabled)}
                    rows={this.state.ets}
                    selectedPage={this.state.page}
                    pageSize={this.state.pageSize}
                    pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                    clearFilters={this.state.clearFilters}
                    filtersApplied={this.state.filtersApplied}
                    onImportChargesClick={this.onClickBulkUpload}
                    sortingAction={this.handleSorting}
                    linkAction={(e: any) => {
                        const url = `/job-costing/ets/${e.id}`;
                        this.linkAction(url);
                    }}
                    nextPageAction={this.handleNextPage}
                    previousPageAction={this.handlePreviousPage}
                    pageChangeAction={this.handlePageChange}
                    pageSizeChanged={this.handlePageSizeChange}
                    downloadToFileAction={(data: any) => { this.bullkDownloadAction(data); }}
                    totalCount={this.state.totalCount}
                    fetchRowsForBulkDownload={isBulkSelectForDownloadEnabled ? this.props.fetchEtsPageForDownload : undefined}
                />
            </Search>
        );
    }
    private bullkDownloadAction = async (data: any) => {
        const ids = data.map((item: any) => item.id);
        if (data.length > 0) {
            await this.props.bulkDownloadETS(ids);
            this.setState({
                showDownloadModal: true,
            });
        }
    };
    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        if (data && data.length) {
            data = data.map((item: any) => {
                if (item.destinationService && item.originService && item.originService.indexOf('/') === -1) {
                    item.originService = `${item.originService}/${item.destinationService}`;
                }
                if (item.rateErrorMessage && item.agedInHrs >= 0) {
                    item.agedTime = getAgingBucket(item.agedInHrs);
                }
                if (item.productType) {
                    item.productType = formatValueIfNullOrUndefined(item.productType);
                }
                return item;
            });
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            ets: [...data]
        });
    };
    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };
    private resetDates = () => {
        if (this.props.ets && this.props.ets.result.length > 0) {
            this.props.resetETS();
        }
        this.setState({
            sorted: [],
            page: 1,
            totalCount: 0,
            etaFrom: false,
            etdFrom: false,
            isFetchinProgress: true,
            ets: [],
            shouldClear: true,
            clearFilters: true,
            hasData: false
        });
    };
    private updatePagination = (page: number = this.props.ets.page) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
            this.tableRef.current.querySelector('input[type=number]').value = page;
        }
    };
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-ets') ?
            localStorage.getItem('pageSize-ListTable jobCosting-search-ets') : pageSize;
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize,
            isPaginationClicked: false
        });
        this.props.fetchETS(page, tempPageSize);
    };
    private fetchReset = (page: number = this.state.page = 1, pageSize: number = 10) => {
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                filtersApplied: true,
            }, () => {
                this.targetFetch(p, pS);
                setTimeout(() => {
                    this.setState({
                        filtersApplied: false
                    });
                }, 100);
            });
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.ets.isFetchDataLoading,
    isFetchSearchDataError: state.ets.isFetchDataError,
    searchPendingError: state.ets.detailsPendingError,
    ets: state.ets.ets,
    currentFilters: state.filters.filters,
    filters: state.filters.hideFilters,
    featureToggles: state.featureToggle.featureToggles,
    userPermissions: state.user.userPermissions,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchETS: (pageNumber: number, pageSize: number) => dispatch(fetchETS(pageNumber, pageSize)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    resetETS: () => dispatch(resetETS()),
    bulkDownloadETS: (ids: []) => dispatch(bulkDownloadETS(ids)),
    fetchEtsPageForDownload: (pageNumber: number, pageSize: number) => dispatch(fetchEtsPageForDownload(pageNumber, pageSize)),
});
const __SearchEts = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchEts);
export const SearchEts = withRouter(__SearchEts);